import React, { useState } from 'react';
import ModalWrapper from './ModalWrapper';
import signsealLogo from './signseal_logo.png';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function LoginModal({ open, onClose, onLoginSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      console.log('Login response status:', response.status);
      console.log('Login response headers:', response.headers);
      
      // Check if response is actually JSON
      const contentType = response.headers.get('content-type');
      console.log('Content-Type:', contentType);
      
      if (!contentType || !contentType.includes('application/json')) {
        const textResponse = await response.text();
        console.error('Non-JSON response received:', textResponse);
        throw new Error('Server returned HTML instead of JSON. Check backend server status.');
      }
      
      const data = await response.json();
      console.log('Login response data:', data);

      if (!response.ok) {
        throw new Error(data.error || 'Login failed');
      }

      // Store token and user info
      localStorage.setItem('authToken', data.token);
      localStorage.setItem('currentUser', JSON.stringify(data.user));

      // Clear form
      setEmail('');
      setPassword('');
      setError('');

      // Notify parent component
      onLoginSuccess(data.user, data.token);
      onClose();

    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setEmail('');
    setPassword('');
    setError('');
    onClose();
  };

  if (!open) return null;

  return (
    <ModalWrapper open={open} onClose={handleClose} zIndex={50} minWidth={420} maxWidth={480}>
      <div style={{
        textAlign: 'center',
        marginBottom: 24
      }}>
        <img 
          src={signsealLogo} 
          alt="SignSeal Logo" 
          style={{
            maxWidth: 180,
            maxHeight: 70,
            marginBottom: 16,
            objectFit: 'contain'
          }} 
        />
        <h2 style={{
          color: '#1976d2',
          fontWeight: 800,
          marginBottom: 8,
          fontSize: 26,
          letterSpacing: 0.5
        }}>
          Stock Management System
        </h2>
        <p style={{
          color: '#666',
          fontSize: 14,
          margin: 0
        }}>
          Please enter your credentials to access the system
        </p>
      </div>

      <form onSubmit={handleSubmit} style={{ width: '100%' }}>
        <div style={{ marginBottom: 16 }}>
          <label style={{ 
            display: 'block', 
            marginBottom: 6, 
            fontWeight: 600, 
            color: '#333' 
          }}>
            Email:
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="Enter your email address"
            style={{
              width: '100%',
              padding: '14px 16px',
              border: '2px solid #e8f0fe',
              borderRadius: 12,
              fontSize: 16,
              outline: 'none',
              transition: 'all 0.3s ease',
              background: '#fafbfc',
              boxSizing: 'border-box'
            }}
            onFocus={(e) => {
              e.target.style.borderColor = '#1976d2';
              e.target.style.background = '#fff';
              e.target.style.boxShadow = '0 0 0 3px rgba(25, 118, 210, 0.1)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#e8f0fe';
              e.target.style.background = '#fafbfc';
              e.target.style.boxShadow = 'none';
            }}
          />
        </div>

        <div style={{ marginBottom: 20 }}>
          <label style={{ 
            display: 'block', 
            marginBottom: 6, 
            fontWeight: 600, 
            color: '#333' 
          }}>
            Password:
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            placeholder="Enter your password"
            style={{
              width: '100%',
              padding: '14px 16px',
              border: '2px solid #e8f0fe',
              borderRadius: 12,
              fontSize: 16,
              outline: 'none',
              transition: 'all 0.3s ease',
              background: '#fafbfc',
              boxSizing: 'border-box'
            }}
            onFocus={(e) => {
              e.target.style.borderColor = '#1976d2';
              e.target.style.background = '#fff';
              e.target.style.boxShadow = '0 0 0 3px rgba(25, 118, 210, 0.1)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#e8f0fe';
              e.target.style.background = '#fafbfc';
              e.target.style.boxShadow = 'none';
            }}
          />
        </div>

        {error && (
          <div style={{
            background: '#ffebee',
            color: '#c62828',
            padding: '12px 16px',
            borderRadius: 8,
            marginBottom: 16,
            border: '1px solid #ffcdd2',
            fontSize: 14,
            fontWeight: 500
          }}>
            {error}
          </div>
        )}

        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', marginTop: 8 }}>
          <button
            type="button"
            onClick={handleClose}
            style={{
              padding: '14px 28px',
              border: '2px solid #e0e0e0',
              background: '#fff',
              color: '#666',
              borderRadius: 12,
              fontSize: 16,
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              minWidth: '120px'
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={loading}
            style={{
              padding: '14px 28px',
              border: 'none',
              background: loading ? '#ccc' : 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
              color: '#fff',
              borderRadius: 12,
              fontSize: 16,
              fontWeight: 700,
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: loading ? 'none' : '0 4px 12px rgba(25, 118, 210, 0.4)',
              minWidth: '120px',
              transform: loading ? 'none' : 'translateY(0)',
            }}
            onMouseEnter={(e) => {
              if (!loading) {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 16px rgba(25, 118, 210, 0.5)';
              }
            }}
            onMouseLeave={(e) => {
              if (!loading) {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 12px rgba(25, 118, 210, 0.4)';
              }
            }}
          >
            {loading ? '🔄 Logging in...' : '🔐 Login'}
          </button>
        </div>
      </form>
    </ModalWrapper>
  );
}
